// @flow
import React, {useEffect} from "react";
import GoogleMapReact from "google-map-react";
import moment from "moment";
import {useTranslation} from "react-i18next";
import apiKey from "../../../../_core/apiKey";
import {MapContainer} from "./styles";
import HomeIcon from "../../../../public/images/home-marker.png";
import CourierIcon from "../../../../public/images/courier-marker.png";
import {InfoCircleOutlined} from "@ant-design/icons";
import {Tooltip} from "antd";

export const CourierDetailMap = ({courier}) => {
    const {t} = useTranslation();

    // Courier objesinden ev ve mevcut konumları çıkar
    const homeLocation = courier?.homeLocation;
    const currentLocation = {
        latitude: courier?.location?.location?.coordinates?.[1],
        longitude: courier?.location?.location?.coordinates?.[0]
    };

    // Markers array'ini oluştur
    const markers = [];

    // Ev konumu kontrolü
    if (homeLocation?.latitude && homeLocation?.longitude) {
        markers.push({
            lat: homeLocation.latitude,
            lng: homeLocation.longitude,
            icon: HomeIcon,
            title: "Ev Konumu"
        });
    }

    // Mevcut konum kontrolü
    if (currentLocation?.latitude && currentLocation?.longitude) {
        markers.push({
            lat: currentLocation.latitude,
            lng: currentLocation.longitude,
            icon: CourierIcon,
            title: "Mevcut Konum"
        });
    }

    // Marker yoksa bile harita göster

    const handleApiLoaded = (map, maps) => {
        if (markers.length > 0) {
            markers.forEach((marker, index) => {
                new maps.Marker({
                    position: {lat: marker.lat, lng: marker.lng},
                    map,
                    icon: {
                        url: marker.icon,
                        scaledSize: new maps.Size(32, 40)
                    },
                    title: marker.title
                });
            });

            // Birden fazla marker varsa harita görünümünü ayarla
            if (markers.length > 1) {
                const bounds = new maps.LatLngBounds();
                markers.forEach(marker => {
                    bounds.extend(new maps.LatLng(marker.lat, marker.lng));
                });
                map.fitBounds(bounds);
            } else {
                // Tek marker varsa o nokta merkezli göster
                map.setCenter({lat: markers[0].lat, lng: markers[0].lng});
                map.setZoom(10);
            }
        }
    };

    const center =
        markers.length > 0
            ? {lat: markers[0].lat, lng: markers[0].lng}
            : {lat: 41.0082, lng: 28.9784}; // İstanbul fallback

    // API key kontrolü
    if (!apiKey) {
        return (
            <MapContainer>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                        backgroundColor: "#f5f5f5",
                        color: "#666"
                    }}
                >
                    Google Maps API anahtarı bulunamadı
                </div>
            </MapContainer>
        );
    }

    return (
        <div>
            <MapContainer>
                <GoogleMapReact
                    bootstrapURLKeys={{key: apiKey, language: "tr"}}
                    defaultCenter={center}
                    defaultZoom={markers.length === 0 ? 6 : markers.length > 1 ? 10 : 10}
                    yesIWantToUseGoogleMapApiInternals
                    onGoogleApiLoaded={({map, maps}) => handleApiLoaded(map, maps)}
                    options={{
                        fullscreenControl: true,
                        gestureHandling: "greedy",
                        zoomControl: true,
                        streetViewControl: false
                    }}
                />
            </MapContainer>
            {markers.length === 0 ? (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        fontSize: "14px",
                        color: "#ff0000",
                        marginTop: "8px",
                        fontStyle: "italic",
                        fontWeight: "900"
                    }}
                >
                    <Tooltip
                        title={
                            <>
                                <p>Olası nedenler:</p>
                                <ul>
                                    <li>
                                        Kurye, henüz aktif olarak çalışmaya başlamamış olabilir.
                                    </li>
                                    <li>
                                        Kurye, mobil uygulama için konum izni vermemiş olabilir.
                                    </li>
                                </ul>
                            </>
                        }
                    >
                        <InfoCircleOutlined style={{marginRight: "4px"}} />
                        Kurye konum bilgisi bulunamadı
                    </Tooltip>
                </span>
            ) : (
                courier?.location?.locationUpdatedAt && (
                    <span
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "8px"
                        }}
                    >
                        {`${t("lastUpdatedDate", {
                            ns: "courierDetail"
                        }) || "Son Güncelleme"}: ${moment(
                            courier?.location?.locationUpdatedAt
                        ).format("Do MMMM YYYY, HH:mm")}`}
                    </span>
                )
            )}
        </div>
    );
};
